import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Menu.module.scss";

const Menu = ({ isOpen, toggleMenu }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (sectionId) => {
    toggleMenu(); // Zatvara meni

    if (location.pathname !== "/") {
      // Ako nisi na "/" -> idi na "/"
      navigate("/");

      // Sačekaj da se ruta promeni, pa onda skroluj
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
      }, 100); // Blaga pauza da sačekamo učitavanje stranice
    } else {
      // Ako si već na "/" -> samo skroluj
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div className={`${styles.overlay} ${isOpen ? styles.showOverlay : ""}`} onClick={toggleMenu}></div>

      <nav className={`${styles.menu} ${isOpen ? styles.open : ""}`}>
        <ul className={styles.navLinks}>
          <li><a onClick={() => handleNavigation("onama")}>Ko smo mi?</a></li>
          <li><a onClick={() => handleNavigation("ponuda")}>Šta je u ponudi?</a></li>
          <li><a onClick={() => handleNavigation("izbor")}>Koji ples biraš?</a></li>
          <li><a onClick={() => window.location.href="/news"}>Šta je novo?</a></li>
          <li><a onClick={() => handleNavigation("kontakt")}>Pleši sa nama</a></li>
        </ul>
      </nav>
    </>
  );
};

export default Menu;
